import {
    FETCH_ESHOP_ENUMS,
    CLEAN_ESHOP_ENUMS,
} from '../actions/types';

const ESHOP_ENUMS_DEFAULT_STATE = [];

const EshopEnumsReducer = (state = ESHOP_ENUMS_DEFAULT_STATE, { type, payload }) => {
    switch (type) {
        case FETCH_ESHOP_ENUMS:
            return payload;

        case CLEAN_ESHOP_ENUMS:
            return ESHOP_ENUMS_DEFAULT_STATE;

        default:
            return state;
    }
};

export default EshopEnumsReducer;
